import React from 'react';
import './BlogCreativeCanvas.css';

export default function BlogCreativeCanvas({ variant, onChange, canvasId = 'blog-creative-canvas' }) {
  // Strip HTML tags from content to prevent them showing in the canvas
  const stripHtml = (str) => {
    if (!str) return str;
    return str.replace(/<[^>]*>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').trim();
  };
  
  const title = stripHtml(variant?.title || 'Your blog title here');
  const message = stripHtml(variant?.message || 'Short excerpt or intro will appear here.');
  const cta = stripHtml(variant?.cta || 'Read more');
  const hashtags = (variant?.hashtags || []).join(' ');

  return (
    <div className="blog-canvas" id={canvasId} role="img" aria-label="Blog creative preview">
      <div className="blog-canvas-inner">
        {/* Logo positioned at top-left like job canvas */}
        <img 
          src="/full_logo.png" 
          alt="Coooly Logo"
          className="brand-logo brand-logo--white"
          style={{
            position: 'absolute',
            top: '-40px',
            left: '0px',
            height: '80px',
            width: 'auto',
            zIndex: 100,
            pointerEvents: 'none',
            filter: 'brightness(0) saturate(100%) invert(1)'
          }}
        />
        <h2 className="blog-title">{title}</h2>
        <p className="blog-message">{message}</p>
        <div className="blog-footer">
          <button className="cta">{cta}</button>
          <div className="hashtags">{hashtags}</div>
        </div>
      </div>
    </div>
  );
}
